import React, { Fragment, useEffect } from 'react'
import useBaseApi from '../hooks/useBaseApi'
import useNavigation from '../hooks/useNavigation'
import useViewer from '../hooks/useViewer'
import CustomToast from '../../../CommonComponents/toast/CustomToast'
import useLoader from '../hooks/useLoader'

const ScenarioDataProvider = ({ children }: { children: React.ReactNode }) => {
    const { loading } = useLoader()
    const { viewer } = useViewer()
    const { getScenarioBaseData } = useBaseApi()
    const { missionId, scenarioId } = useNavigation()

    useEffect(() => {
        if (!missionId || !viewer) return
        getScenarioBaseData(missionId, scenarioId)
    }, [missionId, viewer])

    return (
        <Fragment>
            <CustomToast type='loading' show={scenarioId ? (loading?.base ? true : false) : false} message='Loading Scenario' />
            {children}
        </Fragment>
    )
}

export default ScenarioDataProvider